import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/app/[locale]/academy/not-found.tsx");
